export default "__VITE_ASSET__Dgu1sSRI__"